import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';
import { InterfaceUtilization } from './paf-result-utilization-icon.custom';

@Component({
  shadow: true,
  styleUrl: 'paf-result-utilization-icon.scss',
  tag: 'paf-result-utilization-icon',
})

export class PafResultUtilizationIcon implements ComponentInterface {

  /**
   * The travelClass property will render the class
   * as text.
   */
  @Prop() public travelClass!: string;

  /**
   * Based on the value of the utilization property,
   * the component displays the corresponding utilization
   * icon.
   */
  @Prop() public utilization!: InterfaceUtilization['property'];

  public render(): HTMLDivElement {
    const fileNameModifier = window.matchMedia('(forced-colors: active) and (prefers-color-scheme: dark)').matches
      ? '-high-contrast'
      : '';

    const travelClass = this.travelClass === '1'
      ? '1.'
      : '2.';

    return (
      <div
        class='utilization-icon'
      >
        {travelClass}
        <paf-icon
          name={`utilization-${this.utilization}${fileNameModifier}`}
          variant='utilization'
        ></paf-icon>
      </div>
    );
  }
}
